

function DashboardCards({ src, label, count, onClick  }) {

    return (
        <>
            <div className="el-middle-top-col" >
                <div className="el-middle-top-img"><img src={src} alt={label} /></div>
                <div className="dashboard-card-count el-middle-top-content" onClick={onClick}>
                    <strong>{count}</strong>
                    <span>{label}</span>
                </div>
            </div>
        </>
    );
}
export default DashboardCards;